import { useEffect, useState } from "react";
import { useParams, useNavigate, NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

import { validatePassword } from "../../constants/validate";
import { Button, Input } from "../../components/DesignSystem";

import "./index.scss";

function NewPassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [passwordNotFound, setPasswordNotFound] = useState(false);
  const { hash } = useParams();

  const { user } = useSelector((state) => state.app);

  useEffect(() => {
    const hashDecoded = window.atob(hash);

    const email = hashDecoded.split("/")[0];
    const password = hashDecoded.split("/").splice(1).join("/");

    if (password) {
      navigate("/nova-senha", { replace: true });
      axios
        .post("user/verify-recover-password", { email, password })
        .then((response) => {
          localStorage.setItem("user", JSON.stringify(response.data));
          axios.defaults.headers.common["token"] = response.data.token;
          setUser(response.data);
        })
        .catch((err) => {
          setPasswordNotFound(true);
          console.log(err);
        });
    } else {
      navigate(-1);
    }
  }, []);

  function setUser(user) {
    dispatch({ type: "CHANGE_USER", payload: user });
  }

  function validateNewPassword() {
    if (!newPassword) {
      setError("Senha obrigatória.");
    } else if (newPassword !== confirmNewPassword) {
      setError("Senhas não coincidem.");
    } else if (!validatePassword(newPassword)) {
      setError(
        "Sua senha deve ter no mínimo 8 caracteres contendo letras maiúsculas e minúsculas, números e caracteres especiais."
      );
    } else {
      setError("");
      changePassword();
    }
  }
  function changePassword() {
    setLoading(true);
    axios
      .put("user/change-password", { password: newPassword, email: user.email })
      .then((response) => {
        setLoading(false);
        if (user.roles_id === 3) {
          navigate("/caso");
        } else {
          navigate("/painel/meus-casos");
        }
      })
      .catch((err) => {
        setError("Ocorreu erro, tente novamente.");
        console.log(err);
        setLoading(false);
      });
  }

  function handleClickResetPassword() {
    validateNewPassword();
  }

  return (
    <div className="new-password">
      {!passwordNotFound ? (
        <>
          <h1>Redefina a sua senha</h1>
          <p>
            Por favor, por motivos de segurança recomendamos que você altere a
            sua senha padrão.
          </p>
          <div className="new-password__form">
            <Input
              type="password"
              label="Senha"
              placeholder=""
              onChange={setNewPassword}
              value={newPassword}
              password={true}
            />
            <Input
              type="password"
              label="Confirmar Senha"
              placeholder=""
              onChange={setConfirmNewPassword}
              value={confirmNewPassword}
              password={true}
            />
            <Button
              contained
              loading={loading}
              onClick={handleClickResetPassword}
              style={{ width: "100%" }}
            >
              Redefinir
            </Button>
            <NavLink
              className="new-password__form__reset-later"
              to="/login"
              onClick={() => { }}
            >
              <p>Redefinir depois</p>
            </NavLink>
            <div
              className={
                error
                  ? "login__form__error login__form__error--visible"
                  : "login__form__error"
              }
            >
              <h3>{error}</h3>
            </div>
          </div>
        </>
      ) : (
        <>
          <h1>Link expirado</h1>
          <p>Por favor, utilize um link mais recente.</p>
          <NavLink
            className="new-password__form__go-home"
            to="/"
            onClick={() => { }}
          >
            <p>Voltar para home</p>
          </NavLink>
        </>
      )}
    </div>
  );
}

export default NewPassword;
